<mat-card class="accion-emergencia-dialog">
  <app-card-header
    [title]="titulo"
    subtitle="La emergencia se cierra con el mismo código con el que se abrió"
    icono="cancel"
    tono="peligro"
  ></app-card-header>
  <mat-divider></mat-divider>

  <form [formGroup]="form" (ngSubmit)="guardar()" autocomplete="off">
    <mat-card-content class="card-content-crear cardContentDialog">
      <app-info-banner
        color="orange"
        icon="warning"
        [closable]="false"
        title="La cancelación no se puede deshacer"
        message="Si había un móvil asignado, queda libre para otra emergencia."
      ></app-info-banner>

      <app-content-card title="Cancelación" icon="cancel" color="red">
        <section class="inputs-group">
          <mat-form-field style="width: 100%">
            <mat-icon matPrefix>edit_note</mat-icon>
            <mat-label>Motivo de la cancelación</mat-label>
            <textarea
              matInput
              formControlName="motivoCancelacion"
              rows="3"
            ></textarea>
            @if (form.get('motivoCancelacion')?.invalid) {
              <mat-error>Indicá por qué se cancela</mat-error>
            }
          </mat-form-field>
        </section>
        <section class="inputs-group">
          <mat-form-field style="width: 100%">
            <mat-icon matPrefix>notes</mat-icon>
            <mat-label>Observaciones</mat-label>
            <textarea
              matInput
              formControlName="observaciones"
              rows="2"
            ></textarea>
          </mat-form-field>
        </section>
      </app-content-card>
    </mat-card-content>

    <mat-card-actions class="actions-create">
      <app-button
        matType="mat-fab extended"
        color="neutral"
        text="Volver"
        icon="arrow_back"
        (click)="cerrar()"
      ></app-button>
      <app-button
        matType="mat-fab extended"
        color="warn"
        text="Cancelar emergencia"
        icon="cancel"
        type="submit"
        [disabled]="form.invalid || guardando"
        [loading]="guardando"
      ></app-button>
    </mat-card-actions>
  </form>
</mat-card>
